import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SectiuniPublice, SectiuniPubliceEditPayload } from './sectiuni-publice.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SectiuniPubliceService {
    private token!: string;
    private httpOptions: any;
    private basePath = environment.interop.basePath;

    private getSectiunePublicaUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.sectiuniPublice.getSectiune;

    private storeSectiunePublicaUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.sectiuniPublice.storeSectiune;

    private deleteSectiunePublicaUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.sectiuniPublice.deleteSectiune;

    private updateSectiunePublicaUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.sectiuniPublice.updateSectiuni;


    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.sectiuniPublice
            .changeStatusSectiuniActive;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.sectiuniPublice
            .changeStatusSectiuniPublic;

    constructor(private http: HttpClient) { }

    addSectiune(data: SectiuniPublice) {
        return this.http.post(this.storeSectiunePublicaUrl, data, this.httpOptions);
    }

    getSectiunePublica(id: number) {
        return this.http.get(this.getSectiunePublicaUrl + id, this.httpOptions);
    }

    updateSectiune(data: SectiuniPubliceEditPayload) {
        return this.http.put(this.updateSectiunePublicaUrl, data, this.httpOptions);
    }

    deleteSectiune(id: number) {
        return this.http.delete(this.deleteSectiunePublicaUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }
}
